module.exports = __webpack_public_path__ + "static/img/oillight2.81e89a0a.png";